// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__R4-sY","tooltipArrow":"styles_tooltipArrow__1SZZe"};